<template>
  <template v-if="
    !isWholesaler && !isStaff && !isWholesalerStaff && canSeeWelcomePoints && showWelcomePointsInfo()
  ">
    <p v-if="profilePercentage != 100">
      {{ $t("account.profile.completeProfile") }}
      <span class="success-green fw-bold cursor--pointer" @click="goToMyAccount">
        {{ $t("account.profile.completeProfileBold") }}
      </span>
    </p>
    <p v-else>
      {{ $t("account.profile.fullCompleteProfile") }}
    </p>
  </template>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed, watch, ref, defineProps } from "vue";
import TokenService from "@/services/storage.service";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { getShowWelcomePointsInfo } from "@/composables/useProfileFieldCheck";
import { resolveProfilePercentage } from "@/utils/resolveProfilePercentage";

const props = defineProps({
  to: {
    type: String,
    default: "stammdaten",
  },
});

const store = useStore();
const router = useRouter();
const { tenantConfig } = useTenantConfig();
const { showWelcomePointsInfo } = getShowWelcomePointsInfo(tenantConfig);

const user = computed(() => store.getters.getMe);

const isWholesaler = ref(false);
const isWholesalerStaff = ref(false);
const isStaff = ref(false);
const canSeeWelcomePoints = ref(false);

watch(user, (newVal) => {
  if (newVal && newVal.roles.find((item) => item.name == "wholesaler")) {
    isWholesaler.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "wholesalerStaff")) {
    isWholesalerStaff.value = true;
  }
  if (newVal && newVal.roles.find((item) => item.name == "staff")) {
    isStaff.value = true;
  }

  canSeeWelcomePoints.value = TokenService.showElement("welcomePoints.see");
}, { immediate: true });

const profilePercentage = computed(() => {
  return (
    resolveProfilePercentage(sessionStorage.getItem("percentage")) ??
    resolveProfilePercentage(store.getters.getPercentageNum) ??
    resolveProfilePercentage(store.getters.getProfile?.percentage) ??
    0
  );
});

const goToMyAccount = () => {
  router.push({ name: props.to });
};
</script>
